import { type UseQueryOptions, useQuery } from '@tanstack/react-query';
import {
  type ListTagsV1WorkspacesWorkspaceIdTagsGetData as ListTagsData,
  type ListTagsV1WorkspacesWorkspaceIdTagsGetError as ListTagsError,
  type ListTagsV1WorkspacesWorkspaceIdTagsGetResponse as ListTagsResponse,
  listTagsV1WorkspacesWorkspaceIdTagsGet as listTags,
} from '../../generated';
import { extractTotalCount } from '../../utils';

export type ListTagsQueryVariables = ListTagsData['path'] & NonNullable<ListTagsData['query']>;

export type ListTagsQuery = {
  data: ListTagsResponse;
  total_count: number;
};

export const useListTagsQuery = <TData = ListTagsQuery, TError = ListTagsError>(
  { workspace_id, search, limit, offset }: ListTagsQueryVariables,
  options?: Omit<UseQueryOptions<ListTagsQuery, TError, TData>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery<ListTagsQuery, TError, TData>({
    queryKey: useListTagsQuery.getKey({ workspace_id, search, limit, offset }),
    queryFn: async () => {
      const { data, response } = await listTags({
        path: { workspace_id },
        query: { search: search || undefined, limit, offset },
        throwOnError: true,
      });
      return { data, total_count: extractTotalCount(response, data.length) };
    },
    ...options,
  });
};

useListTagsQuery.getKey = ({ workspace_id, search, limit, offset }: ListTagsQueryVariables) => [
  'ListTags',
  { workspace_id, search, limit, offset },
];
